import { includes } from "ramda";
import apolloProvider from "../apollo-provider";
import CurrentUserQuery from "@/gql/queries/CurrentUserQuery.gql";

const client = apolloProvider.defaultClient;

export const stateGuard = (state) => async (to, from, next) => {
  const result = await client.query({
    query: CurrentUserQuery,
  });

  if (!includes(result.data.currentUser.state, state)) {
    return next({ name: "userProfile" });
  }

  return next();
};
